import {useI18n} from 'i18n/I18nContext'
import usePayment from 'organization/Billing/Payments/usePayment'
import {
  useParamEventId,
  useParamOrganizationId,
} from 'organization/OrganizationRoutes'
import {toast} from 'react-toastify'

export default function useAddonPayment() {
  const {t} = useI18n()
  const {newPayment} = usePayment()
  const organizationId = useParamOrganizationId()
  const eventId = useParamEventId()

  const onSuccess = () => {
    toast.success(t('orgBilling.toastPaymentSuccess'))
  }

  const payment = (requestData: {[x: string]: any}) => {
    return newPayment(
      `api/payment/organization/${organizationId}/event/${eventId}/addon-pay`,
      `api/payment/organization/${organizationId}/event/${eventId}/confirm-addon-pay`,
      requestData,
      onSuccess,
    )
  }

  return {
    payment,
  }
}
